import { combineReducers } from "redux";
import dpSoaReducer from "./dpSoaReducer";
import dpFootnoteConfigReducer from "./dpFootnoteConfigReducer";
import dpFootnoteDataReducer from "./dpFootnoteDataReducer";
import dpFootnoteSoftSaveReducer from "./dpFootnoteSoftSaveReducer";
import dpFinalizeStatusReducer from "./dpFinalizeStatusReducer";

export default combineReducers({
  dpSoaReducer,
  dpFootnoteConfig: dpFootnoteConfigReducer,
  dpFootnoteData: dpFootnoteDataReducer,
  dpFootnoteSoftSave: dpFootnoteSoftSaveReducer,
  dpFinalizeStatus: dpFinalizeStatusReducer,
});
